import { render, staticRenderFns } from "./SubscriptionsManager.vue?vue&type=template&id=923c8a5c&scoped=true&"
import script from "./SubscriptionsManager.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsManager.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsManager.vue?vue&type=style&index=0&id=923c8a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923c8a5c",
  null
  
)

export default component.exports